import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { journeyApi } from "@/lib/journeyApi";

// Authorization-aware route guard. Authorization is confirmed server-side by
// /api/me/role (the frontend check is cosmetic; the API itself enforces access).
// `owner` restricts to the Owner only; otherwise Owner OR Admin is allowed.
// Anyone else - including ordinary customers and logged-out visitors - is
// bounced away and never sees the admin screen.
export function RequireRole({ children, owner = false }) {
  const [state, setState] = useState("checking"); // checking | allowed | denied

  useEffect(() => {
    let active = true;
    journeyApi
      .myRole()
      .then((r) => {
        if (!active) return;
        setState((owner ? r.is_owner : r.is_admin) ? "allowed" : "denied");
      })
      .catch(() => active && setState("denied"));
    return () => { active = false; };
  }, [owner]);

  if (state === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAF8F4]" data-testid="role-guard-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#E5E0D9] border-t-[#2F6B57]" />
      </div>
    );
  }
  if (state === "denied") return <Navigate to="/dashboard" replace />;
  return children;
}
